import React, { FC, useContext, useRef } from 'react'

import { styled } from '@linaria/react'
import { useScroll } from '@react-spring/web'
import { Property } from 'csstype'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { useThemeNext } from 'components/designSystem/shared/themes/useThemeNext'
import { colorInterpolate } from 'functions/colorInterpolate'

import {
  backgrounds as bigImages,
  backgroundsShadow as bigImagesShadow,
} from './assets/button/double/backgroundImages'
import {
  backgrounds as smallImage,
  backgroundsShadow as smallImageShadow,
} from './assets/button/single/backgroundImages'
import { ParentCommon } from './Buttons/buttons.styled'
import { Chat } from './Buttons/Chat'
import { heightContainer } from './Buttons/constants'
import { Like } from './Buttons/Like'
import { UnionButtons } from './Buttons/UnionButtons'
import { findBackgroundImage } from './ControlButtonsBar.functions'
import { isVoteable } from './function/isVoteable'
import { ProfileNextContext } from '../Profile/ProfileMain/context/ProfileNextContext'

export const Mobile: FC<{ scrollableNode: HTMLElement }> = ({
  scrollableNode,
}) => {
  const { place, voteable } = useContext(ProfileNextContext)
  const { colors } = useThemeNext()

  const isAlignRight = place === 'profile' && !voteable
  const hasVoted = isVoteable(place, voteable)
  const unionRef = useRef<HTMLDivElement>(null)
  const chatRef = useRef<HTMLAnchorElement>(null)
  const likeRef = useRef<HTMLAnchorElement>(null)

  /** Вот такой hack, нужен для правильной типизации */
  const parentNodeRef = useRef<HTMLElement>(scrollableNode)
  parentNodeRef.current = scrollableNode

  const _ = useScroll({
    container: parentNodeRef,
    default: {
      immediate: true,
    },

    onChange: ({ value }) => {
      const indexBigImage = findBackgroundImage(value.scrollY, bigImages.length)
      const indexSmallImage = findBackgroundImage(
        value.scrollY,
        smallImage.length
      )

      const _color = colorInterpolate(
        colors.static.white,
        colors.static.black,
        value.scrollY / heightContainer
      )

      if (unionRef.current) {
        if (indexBigImage === -1) {
          unionRef.current.style.backgroundImage = 'none'
        } else {
          unionRef.current.style.backgroundImage = `url(${bigImages[indexBigImage]}), url(${bigImagesShadow[indexBigImage]})`
        }
      }

      if (chatRef.current) {
        chatRef.current.style.color = _color

        if (indexSmallImage === -1) {
          chatRef.current.style.backgroundImage = 'none'
        } else {
          chatRef.current.style.backgroundImage = `url(${smallImage[indexSmallImage]}), url(${smallImageShadow[indexSmallImage]})`
        }
      }

      if (likeRef.current) {
        likeRef.current.style.color = _color
      }
    },
  })

  return (
    <Parent
      $align={isAlignRight ? 'flex-end' : 'space-between'}
      data-name="control-bar-mobile"
    >
      {hasVoted && <Chat ref={chatRef} />}
      <UnionButtons ref={unionRef}>
        {!hasVoted && <Chat ref={chatRef} />}
        {hasVoted && <Like ref={likeRef} />}
      </UnionButtons>
    </Parent>
  )
}

const Parent = styled(ParentCommon)<{ $align: Property.JustifyContent }>`
  display: none;
  grid-auto-flow: column;
  justify-content: ${(props) => props.$align};
  align-items: center;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    display: grid;
  }
`
